



















































































































import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'

import { namespace } from 'vuex-class'
import { Component, Vue } from 'vue-property-decorator'
import { Meta } from '@sophosoft/vue-meta-decorator'
import ApiError from '@/service/ApiError'
import selectLocaleNew from '@/components/lfs/Localiztion/SelectLocaleNew.vue';

type Rule = (value: string) => boolean | string

const auth = namespace('auth')
const profile = namespace('profile')
const event = namespace('event')
const shards = namespace('shards')
const survey = namespace('survey')

@Component({
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    selectLocaleNew
  }
})
export default class SignIn extends Vue {

  @Meta
  getMetaInfo() {
    return {
      title: `LeadFrog - ${ this.$t('signin.title') }`
    }
  }

  @event.Getter('defaultColor') protected eventDefaultColor: any

  protected logo: string = '/leadfrog.png'

  protected login: string = ''
  protected password: string = ''

  protected sideImg: string = '/login-bg.svg'
  protected errors: any = []
  protected error: any = ''

  protected isErrorPass: boolean = false

  protected isPasswordShow: boolean = false

  protected isActiveAgreement: boolean = false

  protected showPassword: boolean = false

  @auth.Action('login') protected authLogin: any
  @auth.State('show') protected show: any

  @event.Action('load') protected eventLoad: any

  @shards.Action('load') protected shardsLoad: any

  @survey.Action('load') protected surveysLoad: any

  @profile.Action('refresh') protected refreshProfile: any

  protected get imgUrl() {
    return this.sideImg
  }

  protected get isValidForm() {
    return this.isActiveAgreement && this.login && this.password
  }
  
  loader:any = null
  loading:boolean = false

  protected tryLogin() {
    const { login, password } = this

    this.error = ''
    this.loader = 'loading'
    this.loading = true

    this.authLogin({ login, password })
      .then((response : any) => {
        const { exhibitor, userCompanyId, showId, eventId } = response

        this.isErrorPass = false

        this.refreshProfile({ showId, exhibitor, userCompanyId })
          .then(() =>
            this.eventLoad({ showId,eventId })
              .then(() => {
                this.$router.push({ name: 'Home' })
              })
              .catch((e: any) => {
                console.error('authLoginError: 1: ', e)
              })
          )
          .catch((e: any) => {
            console.error('authLoginError: 2: ', e)
          })
      })
      .catch((err: any) => {
        console.log(err)
        this.error = ApiError.getError(err.data.error)

        this.isErrorPass = true
        this.loader = null
        this.loading = false
      })
  }
}
